// extracted by mini-css-extract-plugin
export default {"switchContainer":"CustomSwitch_switchContainer__YzF4N","label":"CustomSwitch_label__Q24gk","activeLabel":"CustomSwitch_activeLabel__QI4FF"};